<template>
    <div class="login-container">
        <slot>
        </slot>
    </div>
</template>

<script>
export default {

}
</script>

<style rel="stylesheet/scss" lang="scss">
  @import '_assets/styles/mixin.scss';
  $bg: #2d3a4b;
  $dark_gray: #889aa4;
  $light_gray: #eee;

  .login-container {
    @include relative;
    height: 100vh;
    background: url("../../../assets/img/login_bg02@2x.png");
    background-size: 100% 100%;
    .co {
      color: #fff;
      width: 100%;
      font-size: 14px;
      position: absolute;
      bottom: 108px;
      text-align: center;
      user-select: none;
    }
  }

</style>
